// CSS Modules - component class name: MenuTeaserGrid__

<template>
  <div :class="$style.container">
    <div :class="$style.grid">
      <MenuTeaserColumn
        v-for="elm in gridData"
        :key="elm.title + elm.id"
        :title="elm.title"
        :doubleWide="elm.doubleColumn"
        :columnData="elm.subNav"
      />
    </div>
  </div>
</template>

<script>
import MenuTeaserColumn from "./MenuTeaserColumn/MenuTeaserColumn.vue";

export default {
  name: "MenuTeaserGrid",
  props: {
    gridData: {
      type: Array,
      default: []
    }
  },
  components: {
    MenuTeaserColumn
  }
};
</script>

<style module lang="scss">
@import "./MenuTeaserGrid.scss";
</style>
